import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Check, Heart } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useWishlist } from "../context/WishlistContext";
import { formatEUR } from "../lib/api";

export default function ProductCard({ product, index = 0 }) {
  const { addItem } = useCart();
  const { has, toggle } = useWishlist();
  const [added, setAdded] = useState(false);
  const wished = has(product.id);
  const handleWish = (e) => { e.preventDefault(); e.stopPropagation(); toggle(product.id); };

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addItem(product, 1);
    setAdded(true);
    setTimeout(() => setAdded(false), 1400);
  };

  return (
    <Link
      to={`/producto/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block animate-fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative overflow-hidden rounded-md bg-[color:var(--brand-bg-alt)] aspect-[4/5]">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute top-3 left-3 flex flex-col gap-1.5">
          {product.is_bestseller && (
            <span className="text-[10px] tracking-widest uppercase font-semibold bg-[color:var(--brand-primary)] text-[color:var(--brand-bg)] px-2 py-1 rounded-sm">
              Best Seller
            </span>
          )}
        </div>
        <button
          data-testid={`wishlist-${product.slug}`}
          onClick={handleWish}
          className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center rounded-full bg-white/85 backdrop-blur-sm hover:bg-white transition"
          aria-label="Añadir a favoritos"
        >
          <Heart className={`w-4 h-4 ${wished ? "fill-[color:var(--brand-terracotta)] text-[color:var(--brand-terracotta)]" : "text-[color:var(--brand-primary)]"}`} strokeWidth={1.6} />
        </button>
        <button
          data-testid={`add-to-cart-${product.slug}`}
          onClick={handleAdd}
          className={`absolute bottom-3 right-3 w-11 h-11 flex items-center justify-center rounded-full text-white shadow-md transition-all duration-300 ${
            added
              ? "bg-[color:var(--brand-sage)] scale-110"
              : "bg-[color:var(--brand-primary)] opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 hover:bg-black"
          }`}
          aria-label="Añadir a la cesta"
        >
          {added ? <Check className="w-5 h-5 animate-soft-ping" /> : <Plus className="w-5 h-5" strokeWidth={1.8} />}
        </button>
      </div>

      <div className="mt-4 flex items-start justify-between gap-3">
        <div>
          <p className="eyebrow mb-1">{product.category === "salado" ? "Salado" : product.category === "pack" ? "Pack regalo" : "Dulce"} · {product.weight_g}g</p>
          <h3 className="font-serif text-xl leading-tight text-[color:var(--brand-primary)] group-hover:text-[color:var(--brand-terracotta)] transition-colors">
            {product.name}
          </h3>
        </div>
        <span data-testid={`product-price-${product.slug}`} className="font-serif text-lg text-[color:var(--brand-primary)] shrink-0">
          {formatEUR(product.price_eur)}
        </span>
      </div>
    </Link>
  );
}
